module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("frFo5"))).then(() => parcelRequire('1iHdE'));